import React,{useEffect} from 'react';
import { useDispatch , useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
// import Product from '../components/Product'
import { listProducts } from '../actions/productActions';
import Message from '../components/Message';
import Loader from '../components/Loader';
// import Products from '../products'
// import axios from 'axios'
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
// import TableSortLabel from '@mui/material/TableSortLabel';

import DataTable from 'react-data-table-component';

// const headCells = [
//   { id: 'name', numeric: false, disablePadding: true, label: 'Dessert (100g serving)' },
//   { id: 'nama', numeric: false, disablePadding: true, label: 'Dessert (100g serving)' },
//   { id: 'Harga', numeric: true, disablePadding: false, label: 'Harga' },

// ];



const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    }

  }));

const HomeScreen = (props) => {
  
const columns = [
  {
    name: 'Name',
    selector: 'name',
    sortable: true,
  },
  {
    name: 'Harga',
    selector: 'price',
    sortable: true,
    right: true,
  },
  {
    name: 'Text',
    selector: 'content',
    sortable: true,
    right: true,
  },
  {
    name: 'Gambar',
    cell: row => <div data-tag="allowRowEvents"><div ><img src={"/images/"+row.pic[0].nama} alt={row.name}></img></div>{row.name}</div>,
    sortable: true,
  },
];

    const classes = useStyles()
    const dispatch = useDispatch()

    const productList = useSelector((state) => state.productList)
    const { loading, error, products} = productList
    // console.log(products)

    useEffect(() => {
      dispatch(listProducts())
    }, [dispatch])


  
    return (
        <> 
        <h1>Latest Product adr</h1>
        {loading ? (
      <Loader />
      ) : error ? (

        <Message variant='danger'>{error}</Message>
      ) : (
        <Grid container spacing={3} >
          <div>
 
            {/* <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                            <TableSortLabel
                              active={true} // do some validation to decide where the icon will be displayed
                         
               
                             // <<<<<< This is what you are looking for. OR other icon, this will only show up when active is true
                            >
                            Nama
                            </TableSortLabel>
                              </TableCell>
                            <TableCell>
                            <TableSortLabel
                              active={true} // do some validation to decide where the icon will be displayed
                         
               
                             // <<<<<< This is what you are looking for. OR other icon, this will only show up when active is true
                            >
                            Email
                            </TableSortLabel>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
        {products.map((product) => (

            <TableRow key={product.id}>
                <TableCell>{product.name}</TableCell>
                <TableCell>{product.pic[0].nama}</TableCell>
            </TableRow>

            ))}
            </TableBody>
                </Table>
            </TableContainer> */}

      <DataTable
        title="Adr"
        columns={columns}
        data={products}
      />
        </div>
        </Grid>
       )}
            
        </>
       
    )
}

export default HomeScreen
